var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.079,
    height: 10.687,
    viewBox: "0 0 10.079 10.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Share_Icon_Small",
    "data-name": "Share Icon Small",
    d: "M505.652,395.075a1.5,1.5,0,0,0-.9.3l-4.062-2.346a1.658,1.658,0,0,0,0-.526l4.062-2.345a1.515,1.515,0,1,0-.618-1.22c0,.039,0,.077.006.115l-4.058,2.343a1.813,1.813,0,1,0,0,2.74l4.058,2.343c0,.038-.006.076-.006.115a1.515,1.515,0,1,0,1.515-1.515Z",
    transform: "translate(-497.088 -387.418)",
    fill: "#116ed2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconSmall);
export default __webpack_public_path__ + "static/media/Share Icon Small.4ad83835f6ccb7e7ceb4e7a84f5eb8d1.svg";
export { ForwardRef as ReactComponent };